import './../products/products.scss'
import {  EnvironmentOutlined, SisternodeOutlined,
          RedoOutlined, EyeOutlined, 
          ArrowDownOutlined,ShoppingCartOutlined, 
          ArrowUpOutlined, WhatsAppOutlined,  
          UserOutlined, CloseOutlined, 
          DeleteOutlined, CalendarOutlined, 
          ShoppingOutlined, AppstoreOutlined, 
          RollbackOutlined, SwapOutlined} from '@ant-design/icons';
import React, { useEffect, useState } from 'react';
import { Button, Space, Popover,Popconfirm, Tag, Modal, Tabs, Input, Pagination} from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import config from '../../config';
import MouvClientDetail from './mouvementClientDetail/MouvClientDetail';
import { useSelector } from 'react-redux';
import moment from 'moment';
import MouvementDepart from './MouvementDepart';
import MouvementAll from './MouvementAll';
import MouvementRetour from './MouvementRetour';
import MouvementOneVente from './MouvementOneVente';
import MouvementOneRetour from './MouvementOneRetour';
import MouvementEchange from './MouvementEchange';
import MouvementView from './mouvementView/MouvementView';
import {
  NdoePage, NdoePageHeader, NdoeToolbar, NdoeActionButton,
  NdoeResponsiveTable, NdoeDataCard, NdoeStatusBadge,
  NdoeRecherche, filtreTexte, optionsDe, compterActifs,
} from '../../components/ndoe';

const Mouvement = () => {
    const DOMAIN = config.REACT_APP_SERVER_DOMAIN;
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const scroll = { x: 'max-content' };
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
    const [openLivraison, setOpenLivraison] = useState(false);
    const [openVente, setOpenVente] = useState(false);
    const [openRetour, setOpenRetour] = useState(false);
    const [searchValue, setSearchValue] = useState('');
    // Recherche unifiée : période = rechargement serveur, facettes = affinage
    // de ce qui est déjà à l'écran (construites depuis les données reçues).
    const [marque, setMarque] = useState(undefined);
    const [livreurF, setLivreurF] = useState(undefined);
    const [commune, setCommune] = useState(undefined);
    const [debut, setDebut] = useState('');
    const [fin, setFin] = useState('');
    const [chargePeriode, setChargePeriode] = useState(false);
    const [idClient, setIdClient] = useState({});
    const [idTypeEnLivraison, setIdTypeEnLivraison] = useState({});
    const [idTypeVente, setIdTypeVente] = useState({});
    const [idTypeRetour, setIdTypeRetour] = useState({});
    const [idTypeVenteCommande, setIdTypeVenteCommande] = useState([]);
    const user = useSelector((state) => state.user?.currentUser);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(15);
    const [pagination, setPagination] = useState({
      current: 1,
      pageSize: 15,
    });
    const [totalItems, setTotalItems] = useState('');


      const showModal = (e) => {
        setOpen(true);
        setIdClient(e)
      };

      const showModalEnLivraison = (e,id_commande) => {
        setOpenLivraison(true);
        setIdTypeEnLivraison(e)
        setIdTypeVenteCommande(id_commande)
      };

      const showModalOneVente = (e,id_commande) => {
        setOpenVente(true);
        setIdTypeVente(e)
        setIdTypeVenteCommande(id_commande)
      };

      const showModalOneRetour = (e,id_commande) => {
        setOpenRetour(true);
        setIdTypeRetour(e)
        setIdTypeVenteCommande(id_commande)
      };

      const showModalLivreur = (e) => {
        navigate(`/mouvementOne/${e}`)
      };


      // Le grand livre est append-only (audit E47) : on ne supprime plus un mouvement.
      // Pour corriger, on saisit un ajustement inverse via l'écran « Mouvements ».
      const handleDelete = async (id) => {
        toast.info("Le grand livre de stock ne s'efface pas. Pour corriger un mouvement erroné, saisissez un ajustement inverse (entrée/sortie).");
      };

      const fetchData = async (page = currentPage, size = pageSize) => {
        try {
          const { data } = await axios.get(`${DOMAIN}/api/produit/mouvement`, {
            params: {
              page: page,
              pageSize: size,
            },
          });
          setData(data.items); // Utilisez data.items
          setTotalItems(data.total); // Utilisez data.total
          setLoading(false);
        } catch (error) {
          console.log(error);
          toast.error("Impossible de charger les mouvements.");
          setLoading(false); // Assurez-vous de désactiver le chargement en cas d'erreur
        }
      };


      useEffect(() => {
        fetchData(currentPage, pageSize);
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [currentPage, pageSize]);

      const handleTableChange = (pagination) => {
        setCurrentPage(pagination.current);
        setPageSize(pagination.pageSize);

        setPagination({
          current: pagination.current,
          pageSize: pagination.pageSize,
        });

        fetchData(pagination.current, pagination.pageSize);
      };


      const columns = [
        { title: '#',
          dataIndex: 'id',
          key: 'id',
          render: (text, record, index) => {
            const pageSize = pagination.pageSize || 15;
            const pageIndex = pagination.current || 1;
            return (pageIndex - 1) * pageSize + index + 1;
          }
        },
        {
          title: 'Code',
          dataIndex: 'id_commande',
          key: 'id_commande',
          render: (text, record) => (
            <Tag color="blue">{`${new Date().getFullYear().toString().substring(2)}${record.id_shop.toString().padStart(2, '0')}${record.id_commande.toString().padStart(4, '0')}`}</Tag>
          ),
        },
        {
          title: 'Client',
          dataIndex: 'nom_client',
          key: 'nom_client',
          render : (text,record)=>(
            <div onClick={()=> showModal(record.id_client1)} style={{cursor: 'pointer'}}>
                <Tag color={'green'}><UserOutlined style={{ marginRight: "5px" }} /> {text}</Tag>
            </div>
          )
        },
        {
          title: 'Commune',
          dataIndex: 'nom_commune',
          key: 'nom_commune',
          render : (text,record)=>(
            <div>
                <Tag color={'green'}><EnvironmentOutlined style={{ marginRight: "5px" }} /> {text}</Tag>
            </div>
          )
        },
        {
          title: 'Livreur',
          dataIndex: 'livreur',
          key: 'livreur',
          render : (text,record)=>(
            <Popover content={`Voir toutes les livraisons de ${text}`} placement="top">
              <div style={{cursor: 'pointer'}} onClick={()=> showModalLivreur(record.id_livreur)}>
                <Tag color={'green'}><UserOutlined style={{ marginRight: "5px" }} /> {text}</Tag>
              </div>
            </Popover>
          )
        },
        {
          title: 'Telephone',
          dataIndex: 'telephone',
          key: 'email',
          render: (text) => (
            <Popover content="Discutez avec lui sur WhatsApp" placement="top">
            <Tag
              onClick={() => window.open(`https://wa.me/${text}`, '_blank')}
              color="green"
              style={{ cursor: 'pointer' }}
            >
              <WhatsAppOutlined style={{ color: 'green', marginRight: '5px' }} />
              {text}
            </Tag>
          </Popover>
          ),
        },
        {
          title: 'Détail',
          dataIndex: 'total_varianteproduit',
          key: 'total_varianteproduit',
          sorter: (a, b) => a.total_varianteproduit - b.total_varianteproduit,
          sortDirections: ['descend', 'ascend'],
          render: (text, record) => (
            <Popover
              content="Voir les détails" placement="top"
            >
              <Tag color="blue" icon={<ArrowUpOutlined />} style={{ cursor: 'pointer' }} onClick={()=>showModalEnLivraison(record.id_commande)}>
                {record.total_varianteproduit}
              </Tag>
            </Popover>
          )
        },
        {
          title: 'Nbre vendu',
          dataIndex: 'total_vendu',
          key: 'total_vendu',
          sorter: (a, b) => (a.total_vendu ?? 0) - (b.total_vendu ?? 0),
          sortDirections: ['descend', 'ascend'],
          render: (text, record) => (
            <Popover
              content="Voir le nombre des articles vendus" placement="top"
            >
              <Tag color="green" icon={<ShoppingCartOutlined style={{paddingRight: "5px"}} />} style={{cursor: "pointer"}} onClick={()=> showModalOneVente(record.id_vente, record.id_commande)}>
              {record.total_vendu ?? 0}
              </Tag>
            </Popover>
          )
        },
        {
          title: 'Nbre retourné',
          dataIndex: 'total_retours',
          key: 'total_retours',
          sorter: (a, b) => (a.total_retours ?? 0) - (b.total_retours ?? 0),
          sortDirections: ['descend', 'ascend'],
          render : (text,record)=>(
          <Popover
            content="Voir le nombre des articles retournés" placement="top"
          >
            <Tag color={'red'} icon={<ArrowDownOutlined style={{paddingRight: "8px"}}/>} style={{cursor: "pointer"}} onClick={()=> showModalOneRetour(record.id_retours, record.id_commande)}>{record.total_retours ?? 0}</Tag>
          </Popover>
          )
        },
        {
          title: "Nbre d'échange",
          dataIndex: 'total_echange',
          key: 'total_echange',
          sorter: (a, b) => (a.total_echange ?? 0) - (b.total_echange ?? 0),
          sortDirections: ['descend', 'ascend'],
          render : (text,record)=>(
          <Popover
            content="Afficher le nombre d'articles échangés" placement="top"
          >
            <Tag color={'blue'} icon={<SwapOutlined style={{paddingRight: "8px"}}/>} style={{cursor: "pointer"}}>{record.total_echange ?? 0}</Tag>
          </Popover>
          )
        },
        {
          title: 'Date & Heure',
          width: 176,
          dataIndex: 'date_mouvement',
          key: 'date_mouvement',
          sorter: (a, b) => a.date_mouvement - b.date_mouvement,
          sortDirections: ['descend', 'ascend'],
          render: (text) => (
            <Tag color={'blue'} icon={<CalendarOutlined />}>
              {moment(text).format('DD-MM-yyyy HH:mm')}
            </Tag>
          ),
        },
        {
            title: 'Action',
            key: 'action',
            render: (text, record) => (

              <Space size="middle">
                  <Popover title="Voir la liste de mouvement de cette commande" trigger="hover">
                    <Link to={`/mouvement/${record.id_commande}`}>
                      <Button icon={<EyeOutlined />} style={{ color: 'blue' }} />
                    </Link>
                  </Popover>
                  {user?.role === 'admin' &&
                  <Popconfirm
                    title="Êtes-vous sûr de vouloir supprimer?"
                    onConfirm={() => handleDelete(record.id_mouvement)}
                    okText="Oui"
                    cancelText="Non"
                  >
                    <Button icon={<DeleteOutlined />} style={{ color: 'red' }} />
                  </Popconfirm> }
              </Space>
            ),
          },
      ];

      // Code commande lisible : AA + shop(2) + id(4) (identique au tag "Code" desktop).
      const formatCode = (record) => {
        try {
          return `${new Date().getFullYear().toString().substring(2)}${record.id_shop.toString().padStart(2, '0')}${record.id_commande.toString().padStart(4, '0')}`;
        } catch {
          return record?.id_commande ?? '—';
        }
      };

      // Carte "ligne" pour l'affichage mobile (remplace une ligne de tableau).
      // La suppression reste gardée par user?.role === 'admin' (parité avec la colonne Action).
      const renderMouvementCard = (record) => {
        const phone = record.telephone;
        const actions = [
          <NdoeActionButton key="v" size="sm" variant="ink" icon={<EyeOutlined />} onClick={() => navigate(`/mouvement/${record.id_commande}`)}>Voir</NdoeActionButton>,
          <NdoeActionButton key="d" size="sm" variant="secondary" icon={<ArrowUpOutlined />} onClick={() => showModalEnLivraison(record.id_commande)}>Détail</NdoeActionButton>,
          phone && <NdoeActionButton key="w" size="sm" variant="secondary" icon={<WhatsAppOutlined />} as="a" href={`https://wa.me/${String(phone).replace(/[^0-9]/g, '')}`} target="_blank" rel="noreferrer">WhatsApp</NdoeActionButton>,
          user?.role === 'admin' && (
            <Popconfirm key="del" title="Êtes-vous sûr de vouloir supprimer?" onConfirm={() => handleDelete(record.id_mouvement)} okText="Oui" cancelText="Non">
              <NdoeActionButton size="sm" variant="danger" icon={<DeleteOutlined />}>Suppr.</NdoeActionButton>
            </Popconfirm>
          ),
        ].filter(Boolean);

        return (
          <NdoeDataCard
            title={<><UserOutlined style={{ marginRight: 6 }} />{record.nom_client}</>}
            subtitle={`#${formatCode(record)}${record.nom_commune ? ' · ' + record.nom_commune : ''}${record.livreur ? ' · ' + record.livreur : ''}`}
            badge={record.date_mouvement ? <NdoeStatusBadge kind="custom" tone="neutral" label={moment(record.date_mouvement).format('DD-MM-YYYY')} /> : null}
            metrics={[
              { value: record.total_varianteproduit ?? 0, label: 'détail' },
              { value: record.total_vendu ?? 0, label: 'vendu' },
              { value: record.total_retours ?? 0, label: 'retour' },
              { value: record.total_echange ?? 0, label: 'échange' },
            ]}
            onClick={() => showModal(record.id_client1)}
            actions={actions}
          />
        );
      };

      // ⑤ Feedback : refetch de la liste (au lieu de window.location.reload) + toast.
      const Rafraichir = () =>{
        fetchData(currentPage, pageSize);
        toast.success('Liste actualisée');
      }

    // Zone libre : plusieurs mots = ET (« elie limete » = les mouvements d'Élie
    // à Limete). Avant, c'était un OU sur 5 champs — dès qu'on tapait deux mots,
    // il ne restait plus rien, sans explication.
    const filteredData = (data || [])
      .filter(filtreTexte(searchValue, [
        'type_mouvement', 'nom_client', 'nom_marque', 'nom_commune', 'livreur', 'telephone',
      ]))
      .filter((m) => !marque || String(m.nom_marque) === marque)
      .filter((m) => !livreurF || String(m.livreur) === livreurF)
      .filter((m) => !commune || String(m.nom_commune) === commune);

    // Période — rechargement serveur.
    //
    // ⚠ BUG CORRIGÉ AU PASSAGE : cette route renvoie TOUJOURS `{ items, total }`
    // (produitCtrl:2816), y compris avec des dates. L'ancien panneau faisait
    // `getProduits(data)` et posait donc un OBJET dans l'état ; le
    // `data.filter(...)` du rendu levait aussitôt « filter is not a function ».
    // Autrement dit, « Filtres avancés » cassait la liste des mouvements.
    // On lit `items` (et on tient `total` à jour pour la pagination).
    const chercherPeriode = async () => {
      setChargePeriode(true);
      try {
        const { data: rep } = await axios.get(`${DOMAIN}/api/produit/mouvement`, {
          params: {
            ...(debut && fin ? { start_date: debut, end_date: fin } : {}),
            page: 1,
            pageSize,
          },
        });
        setData(Array.isArray(rep) ? rep : (rep?.items || []));
        if (rep && rep.total !== undefined) setTotalItems(rep.total);
        setCurrentPage(1);
      } catch (error) {
        toast.error('Impossible de charger les mouvements sur cette période.');
      } finally {
        setChargePeriode(false);
      }
    };

    // ----- Onglet "Commandes" (liste paginée serveur, migré design-system) -----
    const tabCommandes = (
      <>
        {/* L'ancien « Filtres avancés » (MouvementSelect) portait la période et
            la marque : les deux sont ici, dans le même outil que la recherche. */}
        <NdoeRecherche
          q={searchValue}
          onQ={setSearchValue}
          placeholder="Cliente, livreur, marque, commune, type de mouvement, téléphone…"
          periode={{ debut, fin }}
          onPeriode={(d, f) => { setDebut(d); setFin(f); }}
          onChercher={chercherPeriode}
          chargement={chargePeriode}
          facettes={[
            { cle: 'marque', placeholder: 'Marque', options: optionsDe(data, 'nom_marque'), valeur: marque, onChange: setMarque, largeur: 150 },
            { cle: 'livreur', placeholder: 'Livreur', options: optionsDe(data, 'livreur'), valeur: livreurF, onChange: setLivreurF, largeur: 150 },
            { cle: 'commune', placeholder: 'Commune', options: optionsDe(data, 'nom_commune'), valeur: commune, onChange: setCommune, largeur: 150 },
          ]}
          actifs={compterActifs(searchValue, marque, livreurF, commune)}
          onEffacer={() => { setSearchValue(''); setMarque(undefined); setLivreurF(undefined); setCommune(undefined); }}
          resume={`${filteredData.length} sur ${data?.length || 0} mouvement${(data?.length || 0) > 1 ? 's' : ''}`}
        />

        <NdoeResponsiveTable
          data={filteredData}
          columns={columns}
          rowKey={(record) => record.id_mouvement ?? record.id_commande}
          loading={loading}
          scroll={scroll}
          pagination={{
            current: currentPage,
            pageSize: pageSize,
            total: Number(totalItems) || 0,
          }}
          onChange={handleTableChange}
          renderCard={renderMouvementCard}
          empty={{ icon: '📦', title: 'Aucun mouvement', text: 'Ajustez la recherche ou les filtres.' }}
          mobilePager={
            <div style={{ marginTop: 16, display: 'flex', justifyContent: 'center' }}>
              <Pagination
                current={currentPage}
                pageSize={pageSize}
                total={Number(totalItems) || 0}
                showSizeChanger={false}
                onChange={(p, s) => handleTableChange({ current: p, pageSize: s })}
              />
            </div>
          }
        />
      </>
    );

    return (
    <NdoePage>
        <NdoePageHeader
          eyebrow="Stock"
          title="Mouvement de stock"
          subtitle="Gérer vos mouvements"
          actions={
            <NdoeActionButton variant="secondary" icon={<RedoOutlined />} onClick={Rafraichir}>
              Actualiser
            </NdoeActionButton>
          }
        />

        <Tabs type="card">
          <Tabs.TabPane
            tab={
              <>
                <ShoppingCartOutlined />Vendus
              </>
            }
            key={0}
          >
            <MouvementDepart />
          </Tabs.TabPane>

          <Tabs.TabPane
            tab={
              <>
                <ShoppingOutlined />Commandes
              </>
            }
            key={1}
          >
            {tabCommandes}
          </Tabs.TabPane>

          <Tabs.TabPane
            tab={
              <>
                <AppstoreOutlined />Tous
              </>
            }
            key={2}
          >
            <MouvementAll />
          </Tabs.TabPane>

          <Tabs.TabPane
            tab={
              <>
                <RollbackOutlined />Retournés
              </>
            }
            key={3}
          >
            <MouvementRetour />
          </Tabs.TabPane>

          <Tabs.TabPane
            tab={
              <>
                <SwapOutlined />Échanges
              </>
            }
            key={4}
          >
            <MouvementEchange />
          </Tabs.TabPane>
        </Tabs>

        <Modal
          title="Information de client"
          centered
          open={open}
          onCancel={() => setOpen(false)}
          width={900}
          footer={[]}
        >
          <MouvClientDetail idClients={idClient}/>
        </Modal>

        <Modal
          title=""
          centered
          open={openLivraison}
          onCancel={() => setOpenLivraison(false)}
          width={1200}
          footer={[]}
        >
          <MouvementView id={idTypeEnLivraison}/>
        </Modal>

        <Modal
          title="Les articles vendus"
          centered
          open={openVente}
          onCancel={() => setOpenVente(false)}
          width={1200}
          footer={[]}
        >
          <MouvementOneVente id_commande={idTypeVenteCommande} id_type={idTypeVente}/>
        </Modal>

        <Modal
          title="Les articles retournés"
          centered
          open={openRetour}
          onCancel={() => setOpenRetour(false)}
          width={1200}
          footer={[]}
        >
          <MouvementOneRetour id_commande={idTypeVenteCommande} id_type={idTypeRetour}/>
        </Modal>
    </NdoePage>
  )
}

export default Mouvement
